import { Component, OnInit } from '@angular/core';
import { Team } from './mockTeam';
import { AssociateService } from '../../associate/shared/services/associate.service';
import { OrganizationService } from '../../shared/services/organization.service';
import { Router, ActivatedRoute, Params, RouterLink} from '@angular/router';
import { MatSnackBar } from '@angular/material';
import { AuthService } from '../../shared/services/auth/auth.service';
import { NotificationService } from '../../shared/services/notification.service';
import { ToastService } from '../../shared/services/toast.service'; 
import { StaticValueService } from '../../shared/services/static-value.service';
import {Sort} from '@angular/material';
import { Configuration } from '../../app.constants';


@Component({
  selector: 'app-new-team',
  templateUrl: './new-team.component.html',
  styleUrls: ['./new-team.component.css']
})
export class NewTeamComponent implements OnInit {
  public team: any = Object.assign({}, new Team().TeamData);
  public organization: any;
  public associateSearch: string;
  public teamSearch: string;
  public autoCompleteAssociateOriginal = []
  public autoCompleteAssociate = [];
  public selectedAssociates= [];
  public teams: any;
  public organizationId: any;
  public parentTeam: any;
  public keyCounter = 0;
  public errors: any;
  public startMemberIndex = 0;
  public serverApiUrl;
  constructor (  public associateSevice: AssociateService,
                public organizationService: OrganizationService,
                public route: ActivatedRoute,
                public router: Router,
                public snackBar: MatSnackBar,
                public authService: AuthService,
                public notificationService: NotificationService,
                public toastService: ToastService,
                public staticDataService: StaticValueService,
                public config: Configuration
              ) { }

  ngOnInit() {
    this.serverApiUrl = this.config.StaticImageUrl;
    if (this.organizationService.companyName === undefined) {
      this.router.navigate(['/home/organization/organization-list']);
    }
    this.route.params.subscribe(params => {
      this.organizationId = params['organization_id'];
    });

    this.staticDataService.getErrors().then(data=>{this.errors=data;})
    this.organizationService.getOrganization( this.organizationId).subscribe((data) => {
      this.organization = data['data'][0];
      this.autoCompleteAssociate = this.organization.associates;
      this.autoCompleteAssociate = this.autoCompleteAssociate.filter( assc => assc.active !== false);
      this.autoCompleteAssociateOriginal = this.organization.associates;
      this.autoCompleteAssociateOriginal = this.autoCompleteAssociateOriginal.filter( assc => assc.active !== false);
      this.teams = data['data'][0]['teams'].filter(team => {
        if (team.active === true) {
          return team;
        }
      } );
    }, (error) => {
    });
  }

  associateTyped() {
    this.autoCompleteAssociate = this.autoCompleteAssociateOriginal.filter(
      singleItem => singleItem['name'].toLowerCase().includes(this.associateSearch.toLowerCase()));
  }
  clickDropDown(recievedAssociate: any, obj: string, index: number) {
    if (obj === 'associates' ) {
      let associateExists = [];
      associateExists  = this.selectedAssociates.filter(assc => {
        if (assc.id === recievedAssociate.associateId ) {
          return assc;
        }
      });
      if (associateExists.length > 0) {
        this.snackBar.open('Associate already exists in this team', '', {
          duration: 3000
        });
      } else {
        const associate = {
          'name': recievedAssociate.name,
          'id': recievedAssociate.associateId,
          'jobTitle': recievedAssociate.jobTitle,
          'groupId': recievedAssociate.groupId,
          'avatarUrl': recievedAssociate.avatarUrl,
          'contactInfo': recievedAssociate.email,
          'jobCategory': recievedAssociate.jobCategory,
          'email': recievedAssociate.email,
          'contactNumber': recievedAssociate.contactNumber,
          'localId': recievedAssociate.localId
        }
        this.selectedAssociates.push(associate) ;
      }
    }
  }
  saveTeam() {
    if (this.parentTeam) {
      this.team.teamDetail.parentTeam.teamId = this.parentTeam._id;
      this.team.teamDetail.parentTeam.name = this.parentTeam.teamDetail.name;
    }
    for (let i = 0 ; i < this.selectedAssociates.length; i++ ) {
      let assc = {'id' : this.selectedAssociates[i].id};
      this.team.members.associates.push(assc);
    }
    let tempLastEdited = {
      'time': new Date(),
      // tslint:disable-next-line:max-line-length
      'name': this.authService.user.isProxyUser ? this.authService.user.name + ` (${this.authService.user.proxyUser.fullName})` : this.authService.user.name,
      'id': this.authService.user.associateId
      };
    this.team.teamDetail.lastEditedBy = Object.assign({}, tempLastEdited);
    this.team.members.lastEditedBy = Object.assign({}, tempLastEdited);
    this.team.lastEdited.push(tempLastEdited);
    this.organizationService.createTeam(this.organizationId, this.team).subscribe((data) => {
      this.team.members.associates.forEach(assc => {
        this.notificationService.sendNotification(assc.id,
          `You have been added to the team <b>${this.team.teamDetail.name}</b>`, 'Organization',
        `home/organization/team-profile/edit/${data['teamId']}/${this.organizationId}`);
      });
      if (this.team.teamDetail.teamLeader.id !== '' ) {
        this.notificationService.sendNotification(this.team.teamDetail.teamLeader.id,
          `You are now Team Leader of <b>${this.team.teamDetail.name}</b>`, 'Organization',
          `home/organization/team-profile/edit/${data['teamId']}/${this.organizationId}`);
      }
      // send notifications to Opco Leader and HR Leader and HR Teams
      this.notificationService.sendNotification(this.organizationService.hrLeaderId,
        `Team <b>${this.team.teamDetail.name}</b>has been added to company <b>${this.organization.company.companyName}</b>`,
            'Organization',  `home/organization/team-profile/edit/${data['teamId']}/${this.organizationId}`);
      this.notificationService.sendNotification(this.organizationService.companyLeaderId,
        `Team <b>${this.team.teamDetail.name}</b> has been added to company <b>${this.organization.company.companyName}</b>`,
                'Organization',  `home/organization/team-profile/edit/${data['teamId']}/${this.organizationId}`);
      this.organizationService.hrTeamIds.forEach(hrId => {
        this.notificationService.sendNotification(hrId,
          `Team <b>${this.team.teamDetail.name}</b> has been added to company <b>${this.organization.company.companyName}</b>`,
                'Organization',  `home/organization/team-profile/edit/${data['teamId']}/${this.organizationId}`);
      });
      this.router.navigate(['/home/organization/profile/view', this.organizationId,'teams']);
      this.snackBar.open('Team Created', '', {
        duration: 3000
      });
    }, (error) => {
      console.log(error);
      this.toastService.error(this.errors.Server['501']);
      this.team = Object.assign({}, new Team().TeamData);
    });
  }
  removeAssociate(index) {
    this.selectedAssociates.splice(index, 1);
  }

  getServerData(event) {
    this.startMemberIndex = event.pageIndex * event.pageSize;
  }

  sortData(sort: Sort) {
    let data = Object.assign([],this.selectedAssociates);
    if (!sort.active || sort.direction === '') {
      return;
    }
    let isAsc = sort.direction === 'asc';
    let sortedList = data.sort((a, b) => {
        switch (sort.active) {
          case 'name': return this.compare(a.name.toLowerCase(), b.name.toLowerCase(), isAsc);
          case 'jobCategory': return this.compare(a.jobCategory.toLowerCase(), b.jobCategory.toLowerCase(), isAsc);
          default: return 0;
        }
    });
    this.selectedAssociates = sortedList;
  }
    
  compare(a, b, isAsc) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
}
